import {Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, HostListener} from '@angular/core';

@Component({
    selector: 'range-slider-component',
    templateUrl: './range-slider.component.html',
    styleUrls: ['./range-slider.component.scss']
})
export class RangeSliderComponent implements OnInit {

    @HostListener('window:mousemove', ['$event']) onScreenMove(event) {
        if(this.isDown){
            this.mouseX = event.clientX;
            this.calcPos();
            document.getElementById("root").classList.add("no-select");
        }
    }

    @HostListener('window:touchmove', ['$event']) onScreenMoveTouch(event) {
        if(this.isDown){
            this.mouseX = event.touches[0].clientX;
            this.calcPos();
            document.getElementById("root").classList.add("no-select");
        }
    }

    @HostListener('window:mouseup') onScreenUp() {
        if(this.isDown){
            this.isDown = false;
            document.getElementById("root").classList.remove("no-select");
        }
    }

    @HostListener('window:touchend') onScreenUpTouch() {
        if(this.isDown){
            this.isDown = false;
            document.getElementById("root").classList.remove("no-select");
            
        }
    }

    @ViewChild('range')range: ElementRef;

    @Input() value: number = 0;
    @Input() min: number = 0;
    @Input() max: number = 100;
    @Input() stepSize: number = 1;
    @Input() rangeStyle: any;
    @Input() markerStyle: any;

    @Output() valueChange = new EventEmitter();


    public position: number = 60;
    private isDown: boolean = false;

    public mouseX: number = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(){
        this.calcPos();
    }

    ngAfterViewInit(): void {
    }

    onTouchmove() {
        console.log('move');
    }



    onDown(event) {
        document.getElementById("root").classList.add("no-select");
        this.isDown = true;
        console.log('isdown');
    }

    

    onRange(event){
        this.isDown = true;
        this.mouseX = event.clientX;
        this.calcPos();
    }
    
    onRangeTouch(event){
        this.isDown = true;
        this.mouseX = event.touches[0].clientX;
        this.calcPos();
    }

    calcPos() {


        if(this.isDown){
            let element = this.range.nativeElement.getBoundingClientRect();

            let position = (this.mouseX - element.left) / element.width;

            if(position > 1){
                position = 1;
            }
            if(position < 0){
                position = 0;
            }

            let oneUnitInPercent = this.min/this.max;

            let stepUnitInPercent = this.stepSize/this.max;

            position = Math.round((position-stepUnitInPercent) / stepUnitInPercent) * stepUnitInPercent + oneUnitInPercent;

            if(position < oneUnitInPercent){
                position = oneUnitInPercent;
            }

            this.valueChange.emit(Math.round(this.max * position));
            this.position = position * 100;
        } else {
            this.position = this.value/this.max*100;
        }


    }






}



// WEBPACK FOOTER //
// ./src/app/components/range-slider/range-slider.component.ts